import { render, staticRenderFns } from "./IsPetAllowed.vue?vue&type=template&id=3e6c41f2&"
import script from "./IsPetAllowed.vue?vue&type=script&lang=ts&"
export * from "./IsPetAllowed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports